package net.sergeych.kilogin.client

import net.sergeych.kilogin.decodeBipack

/**
 * Login client has a _login state_ which represents known state of the log-in protocol.
 * It can properly process offline state and reconnection and report state bu mean
 * of the state flow pf instanses of this class. See [KiloginClient.state].
 */
sealed class LoginState(val isLoggedIn: Boolean) {
    /**
     * User is logged in (either connected or yet not). Client application should save
     * updated [clientData] at this point
     */
    class LoggedIn<D>(val clientData: ClientSecretData<D>) : LoginState(true)

    /**
     * Login state whatever it was now is logged out, and client application should delete
     * any saved [ClientSecretData] instance it has.
     */
    object LoggedOut : LoginState(false)

    /**
     * Returns secret data of the current logged-in user, or null if not logged in,
     * or the secret data were not provided during registration. The secret data
     * in concern are `secretData` argument of [KiloginClient.register].
     */
    inline fun <reified D> unpackSecretDataOrNull(): D? =
        if (this is LoggedIn<*>)
            this.clientData.packedSecretData?.decodeBipack<D>()
        else null
}